import React, { Component } from 'react';

import formatNum from 'utils/formatNum';

import { pokemon } from 'data/pokemon';

import TypeBadge from 'components/TypeBadge';

class RaidBossCard extends Component {
  componentDidMount() {
    var thisPokemon = pokemon.find((pokemon) => {
      return pokemon.name === this.props.raid.name;
    });
    
    window.PkSpr.decorate('pkmn-' + formatNum(thisPokemon.number, 3));
  }

  render() {
    const raid = this.props.raid;
    const thisPokemon = pokemon.find((pokemon) => {
      return pokemon.name === raid.name;
    });

    return (
      <div className="RaidBossCard  g:12  p:xs p-y:s  bgc:white c:dark-pewter">

        <div className="gcol:2">
          <div className="RaidBossCard__Image  m-t:xs  ta:c">
            <span id={'pkmn-' + formatNum(thisPokemon.number, 3)} className={'pkspr pkmn-' + formatNum(thisPokemon.number, 3)}></span>
          </div>
        </div>

        <div className="gcol:7  p-x:s">
          <div className="RaidBossCard__Name c:black">
            {raid.name}
          </div>

          <div className="m-t:xs c:pewter ts:small">
            <div className="RaidBossCard__Tier">
              Tier <span className="c:dark-pewter">{raid.tier}</span>
            </div>
            <div className="RaidBossCard__CaptureRate">
               Capture rate <span className="c:dark-pewter">{raid.bossCaptureRate || '?'}%</span>
            </div>
          </div>
        </div>

        <div className="gcol:3  p-r:xs  ta:r">
          <div className="RaidBossCard__Cp  m-b:xs   ws:nw">
            <span className="ts:tiny ls:s c:pewter">CP</span> {raid.bossCp || '???'}
          </div>

          <div className="RaidBossCard__Type">
            <div className="m-l:a s(m-t:xs)" style={{maxWidth: '90px'}}>
              {thisPokemon.type.map((type) => {
                return (
                  <TypeBadge type={type} key={type} />
                )
              })}
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default RaidBossCard;



// WEBPACK FOOTER //
// ./src/components/RaidBossCard.js